import { Flex } from 'shared';

import {
  JournalCardReplies,
  JournalNote,
  JournalNoteCardReactions,
  JournalCardUnreadIndicator,
  JournalCard,
} from 'features/journal';
import { User } from 'features/user/User';

type TJournalNotesItem = {
  note: JournalNote;
  isAuthor: boolean;
  setEditedNote: (note: JournalNote) => void;
  participantId: string;
  user: User;
};

export const JournalNotesItem = ({
  note,
  isAuthor,
  setEditedNote,
  participantId,
  user,
}: TJournalNotesItem) => (
  <Flex
    flexDirection="column"
    width="100%"
    gap="1rem"
    position="relative"
    data-testid="journal-sidebar-item-card"
  >
    {!note.isRead && (
      <JournalCardUnreadIndicator
        options={{
          left: '-0.75rem',
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      />
    )}
    <JournalCard note={note} setEditedNote={setEditedNote} isAuthor={isAuthor}>
      <JournalCardReplies
        repliesCount={note.repliesCount}
        noteId={note.noteId}
        hasUnreadReplies={note.hasUnreadReplies}
      />
      <JournalNoteCardReactions
        noteId={note.noteId}
        reactions={note.reactions}
        isNoteRead={note.isRead}
        participantId={participantId}
        user={user}
      />
    </JournalCard>
  </Flex>
);
